import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Color, Size } from '../../../const'
import { Button } from '../../shard'

export const Modal = ({ title, text, caution, display, overlayOnClick, buttonOnClick, button = 'OK' }) => (
  <Wrapper display={display ? 1 : 0}>
    <Overlay onClick={overlayOnClick}></Overlay>
    <Content>
      <Title>{title}</Title>
      <Separator />
      <Text>{text}</Text>
      <Caution>{caution}</Caution>
      <ButtonWrapper>
        <Button type="button" primary onClick={buttonOnClick}>
          {button}
        </Button>
      </ButtonWrapper>
    </Content>
  </Wrapper>
)

const getDisplay = (props) => {
  let display = 'none'

  if (props.display || props.display === 1) {
    display = 'inline'
  }

  return display
}

const Wrapper = styled.div`
  ${(props) => css`
    display: ${getDisplay(props)};
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
  `}
`
const Overlay = styled.div`
  background: ${Color.BACKGROUND.POPUP_GRAY};
  position: absolute;
  height: 100vh;
  width: 100%;
`
const Content = styled.div`
  background: ${Color.BACKGROUND.BASE};
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 239px;
  max-width: 354px;
  transform: translate(-50%, -50%);
  padding: 22px 28px 30px 28px;
  text-align: center;
  border-radius: 8px;
`
const Title = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.BIG};
  padding-bottom: 19.5px;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`
const Text = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.REGULAR};
  padding: 11px 14px 0px 14px;
`
const Caution = styled.div`
  color: ${Color.FONT.STEEL};
  font-size: ${Size.FONT.REGULAR};
  padding: 0 14px 40px 14px;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`

Modal.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  caution: PropTypes.string,
  display: PropTypes.bool,
  overlayOnClick: PropTypes.func,
  buttonOnClick: PropTypes.func,
  button: PropTypes.string,
}
